import { usePrivy, useWallets } from '@privy-io/react-auth';
import { useMemo } from 'react';

export const useCurrentPrivyWallet = () => {
  const { wallets } = useWallets();
  const { authenticated: privyAuthenticated, user, ready } = usePrivy();

  /* If wallet walletClientType privy is present in wallet priority is given to it
    social wallets are only present in the array if the user has connected with them 
    this makes sure that the dapp always connects to the correct wallet
   */
  const currentWallet = useMemo(() => {
    return wallets.find((wallet) => wallet.address === user?.wallet?.address);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallets.length, user?.wallet?.address]);

  const authenticated = useMemo(() => {
    return ready && privyAuthenticated && currentWallet?.address !== undefined;
  }, [ready, privyAuthenticated, currentWallet?.address]);

  return useMemo(() => {
    return {
      currentWallet,
      authenticated,
      ready,
      privyAuthenticated,
    };
  }, [currentWallet?.address, authenticated, ready, privyAuthenticated]);
};
